<template>
    <div>
        {{value}}
        <slot :data="value">

        </slot>
    </div>
</template>

<script>
    export default {
        name: "k-btn-checkbox-group",
        props : ["value"],
        data(){
            return {
                checked: [...this.value]
            }
        },
        model : {
            prop : 'value',
            event : 'change'
        },
        watch : {
            checked(nv){
                this.$emit('change', nv )
            }
        }
    }
</script>

<style scoped>

</style>